import RespostaRegistrada from './RespostaRegistrada';

export default RespostaRegistrada;
